import { render } from "./CancelSales.vue?vue&type=template&id=805f24bc"
import script from "./CancelSales.vue?vue&type=script&lang=js"
export * from "./CancelSales.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__